import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "cv_admin_token";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passcode, setPasscode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  // If already authenticated, bounce to /admin
  useEffect(() => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) return;
    axios
      .get(`${API}/cv-admin/me`, { headers: { Authorization: `Bearer ${t}` } })
      .then(() => nav("/admin", { replace: true }))
      .catch(() => localStorage.removeItem(TOKEN_KEY));
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/cv-admin/login`, {
        email: email.trim().toLowerCase(),
        password,
        passcode: passcode.trim(),
      });
      localStorage.setItem(TOKEN_KEY, data.token);
      nav("/admin", { replace: true });
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Couldn't sign you in. Check your details and try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-shell admin-login-shell" data-testid="admin-login-page">
      <form className="admin-card admin-login-card" onSubmit={submit} data-testid="admin-login-form">
        <div className="admin-login-brand">
          <span className="logo"><span className="wm">Clear<span className="wm-accent">view</span>.</span></span>
          <div className="admin-login-sub">Admin</div>
        </div>

        <label className="admin-field">
          <span>Email</span>
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-login-email"
            required
          />
        </label>
        <label className="admin-field">
          <span>Password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-login-password"
            required
          />
        </label>
        <label className="admin-field">
          <span>Passcode</span>
          <input
            type="password"
            inputMode="numeric"
            autoComplete="one-time-code"
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
            data-testid="admin-login-passcode"
            required
          />
        </label>

        {err && <div className="admin-error" data-testid="admin-login-error">{err}</div>}

        <button
          type="submit"
          className="pill pill-grad admin-login-btn"
          disabled={busy}
          data-testid="admin-login-submit"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
